module.exports = __webpack_public_path__ + "img/5大学生社会实践基地.0ae67058.jpg";